import React from "react";
import css from "./QuestionDefinitionsCloseButton.css";
import Icon from "../SF/MaterialIcon"
import PropTypes from 'prop-types';

const QuestionDefinitionsCloseButton = React.forwardRef((props, ref) => {
    return (
      <div aria-label="Close Column Information Drawer"
           role="button"
           id={"questionDefinitionsCloseButton"}
           tabIndex="0"
           ref={ref}
           className={css['closeButton']}
           onClick={props.onClick}>
        <Icon className={css['closeIcon']} icon="close"/>
      </div>
    );
});

QuestionDefinitionsCloseButton.propTypes = {
    onClick: PropTypes.func.isRequired
}

export default QuestionDefinitionsCloseButton;
